$(function(){

  //PC
     $(window).scroll(function () {
      var scrollTop = $(window).scrollTop();
      if( -50 < scrollTop && scrollTop < $('#MainContent').offset().top ){
        $('.commonnavmenu').removeClass('pcnavmenu');
      }else{
        $('.commonnavmenu').addClass('pcnavmenu');       
      }
     });
      var scrollTop = $(window).scrollTop();
         if( -50 < scrollTop && scrollTop < $('#MainContent').offset().top ){
           $('.commonnavmenu').removeClass('pcnavmenu');
      }else{
           $('.commonnavmenu').addClass('pcnavmenu');
      }

  //SP
     $(window).scroll(function () {
      var scrollTop = $(window).scrollTop();
      if( -50 < scrollTop && scrollTop < $('#MainContent').offset().top ){
           $('.sp_commonnavmenu').removeClass('spnavmenu');
      }else{
           $('.sp_commonnavmenu').addClass('spnavmenu');    
      }
     });
      var scrollTop = $(window).scrollTop();
         if( -50 < scrollTop && scrollTop < $('#MainContent').offset().top ){
           $('.sp_commonnavmenu').removeClass('spnavmenu');
      }else{
           $('.sp_commonnavmenu').addClass('spnavmenu');
      }
  
});